import { getAuthHeaders as getHttpAuthHeaders } from './http';

export function getAuthHeaders(token?: string | null): HeadersInit {
  return getHttpAuthHeaders(token || undefined);
}
